import { Button, Checkbox, i18n, useGlobalModalContext } from "rujira.ui";
import { useNotifications } from "../../services/notifcation";
import notification from "../assets/notification.gif";

export const NotificationModal = ({ hideModal }: { hideModal: () => void }) => {
  const { dontShow, setDontShow, requestPermission } = useNotifications();

  return (
    <>
      <img
        src={notification}
        alt=""
        className="filter-orange block w-6 h-a mb-2"
      />
      <div className="modal__header">
        <i18n.h2>Enable Push Notifications?</i18n.h2>
      </div>
      <i18n.p className="lh-19">
        Enable browser notifications for Rujira to receive notifications of
        successful transactions, when orders are filled, and other important
        updates.
      </i18n.p>
      <Checkbox
        id="hidemsg"
        className="mt-4"
        label="Don't ask me again"
        checked={dontShow}
        onChange={() => setDontShow(!dontShow)}
      />
      <div className="modal__footer mt-4 px-3 py-2 flex ai-s wrap">
        <Button
          className="button--grey button--outline mr-1"
          onClick={() => hideModal()}
          label="Cancel"
        />
        <div className="block ml-a text-right">
          <Button
            className="ml-a"
            label="Enable Notifications"
            onClick={() => {
              requestPermission().then(hideModal);
            }}
          />
        </div>
      </div>
    </>
  );
};

export const useNotificationModal = () => {
  const { showModal, hideModal } = useGlobalModalContext();
  const { dontShow } = useNotifications();

  const request = () => {
    if (Notification.permission === "default" && !dontShow) {
      showModal({
        //title: "Important Information",
        backgroundClose: true,
        children: <NotificationModal hideModal={hideModal} />,
      });
    }
  };
  return { request };
};
